<div
  class="iris-full-screen-modal"
  role="dialog"
  aria-modal="true"
  tabindex="0"
>
  <ng-container *ngIf="contentType === contentTypeEnum.TEMPLATE">
    <ng-container *ngTemplateOutlet="contentTemplate; context: $any(context)"></ng-container>
  </ng-container>

  <ng-container *ngIf="contentType === contentTypeEnum.COMPONENT">
    <ng-container *ngComponentOutlet="contentComponent"></ng-container>
  </ng-container>
</div>
